import { styled } from '@mui/system'

import colors from '../../../theme/colors'

// Shared styling for every rich text editor and read-only view
const StyledRichTextEditor = styled('div')(({ theme }) => ({
  '& .rich-text-field.error': {
    border: `1px solid ${theme.palette.error.dark} !important`,
    outline: 'none !important'
  },
  '& .rich-text-field.error:focus-within': {
    border: `2px solid ${theme.palette.error.dark} !important`,
    borderColor: `${theme.palette.error.dark} !important`,
    outline: 'none !important'
  },
  '& .rich-text-field': {
    border: `1px solid ${theme.palette.grey[100]} !important`,
    borderRadius: '4px !important',
    padding: '8px 14px !important',
    backgroundColor: theme.palette.common.white,
    boxSizing: 'border-box !important',
    transition: 'border-color 0.3s ease-in-out !important'
  },
  '& .rich-text-field:not(.error):focus-within': {
    border: `2px solid ${theme.palette.info.dark} !important`,
    borderColor: `${theme.palette.info.dark} !important`,
    outline: 'none !important'
  },
  '& .rich-text-field.disabled': {
    backgroundColor: ` ${theme.palette.action.muiDisabled} !important`,
    cursor: 'auto !important'
  },
  // Faded read-only look used by the typesafe forms and read-only views
  '& .rich-text-field.disabled.faded': {
    pointerEvents: 'none !important',
    opacity: 0.7
  },
  // Override mui-tiptap readonly text color to be black
  '& .rich-text-field.disabled.faded .ProseMirror, & .rich-text-field.disabled.faded .ProseMirror p':
    {
      color: '#000 !important'
    },
  // Links stay clickable even where the field ignores pointer events
  '& .ProseMirror a': {
    pointerEvents: 'auto',
    color: theme.palette.info.dark
  },
  '& .ProseMirror a.m2-link-button': {
    display: 'inline-block',
    padding: '4px 14px',
    margin: '2px 0',
    borderRadius: '4px',
    // Same look as the primary atoms/Button
    backgroundColor: colors.petrol,
    color: `${theme.palette.common.white} !important`,
    fontWeight: 500,
    textDecoration: 'none',
    lineHeight: 1.75
  },
  '& .ProseMirror a.m2-link-button:hover': {
    backgroundColor: theme.palette.secondary.main,
    color: `${theme.palette.common.black} !important`
  },
  // Tables (Tiptap renders no borders by default)
  '& .ProseMirror table': {
    borderCollapse: 'collapse',
    tableLayout: 'fixed',
    width: '100%',
    margin: '8px 0',
    overflow: 'hidden'
  },
  '& .ProseMirror th, & .ProseMirror td': {
    border: `1px solid ${theme.palette.grey[300]}`,
    padding: '6px 8px',
    verticalAlign: 'top',
    boxSizing: 'border-box',
    position: 'relative',
    minWidth: '1em'
  },
  '& .ProseMirror th': {
    backgroundColor: theme.palette.grey[100],
    fontWeight: 'bold',
    textAlign: 'left'
  },
  '& .ProseMirror .selectedCell:after': {
    content: '""',
    position: 'absolute',
    inset: 0,
    backgroundColor: `${theme.palette.info.light}33`,
    pointerEvents: 'none'
  },
  '& .ProseMirror .column-resize-handle': {
    position: 'absolute',
    right: '-2px',
    top: 0,
    bottom: 0,
    width: '4px',
    backgroundColor: theme.palette.info.dark,
    pointerEvents: 'none'
  }
}))

export default StyledRichTextEditor
